import Base from "@/controllers/base";
export default class Topbar extends Base {
  constructor(elem) {
    super(elem);
  }

  static events() {
    const topbar = document.querySelector(".topbar.vued");
    if (!topbar) {
      setTimeout(() => Topbar.events(), 100);
    } else {
      topbar.querySelectorAll(".dropdown").forEach((dropdown) => {
        if (dropdown.hasAttribute("dropdown-handler")) return;
        dropdown.setAttribute("dropdown-handler", true);

        const dropdownMenu = dropdown.querySelector(".dropdown-menu");
        if (dropdownMenu) {
          dropdown.addEventListener("mouseenter", (event) => {
            clearTimeout(dropdown.leaveTimeout);
            dropdown.enterTimeout = setTimeout(() => {
              dropdownMenu.classList.add("hover");
            }, 750);
          });

          dropdown.addEventListener("mouseleave", (event) => {
            clearTimeout(dropdown.enterTimeout);
            dropdown.leaveTimeout = setTimeout(() => {
              dropdownMenu.classList.remove("hover", "instant");
            }, 750);
          });

          if (dropdown.classList.contains("topbar-info-item")) {
            dropdown.addEventListener("click", (event) => {
              if (event.target.closest(".dropdown-menu")) return;
              clearTimeout(dropdown.enterTimeout);
              clearTimeout(dropdown.leaveTimeout);
              dropdownMenu.classList.add("instant", "hover");
            });
          }
        }
      });

      document.addEventListener("contextmenu", (event) => {
        const dropdown = event.target.closest(".dropdown");
        if (dropdown) {
          const dropdownMenu = dropdown.querySelector(".dropdown-menu");
          if (dropdownMenu) {
            dropdown.querySelectorAll("input, textarea").forEach((elem) => {
              if (elem.hasAttribute("contextmenu-handler")) return;
              elem.setAttribute("contextmenu-handler", true);
              elem.addEventListener("paste", (evt) => {
                dropdownMenu.classList.add("sticky");
                evt.target.focus();
                setTimeout(() => dropdownMenu.classList.remove("sticky"), 3000);
              });
            });
          }
        }
      });
    }
  }
}

document.addEventListener("turbo:load", () => {
  Topbar.events();
});
